export const LANGUAGES = [
  { id: 1, name: 'English', is2: 'EN' },
  { id: 2, name: 'Français', is2: 'FR' },
];
